import React from "react";

const JumpToNextBrand = ({ brandName }) => {


    const handleScrollToNextBrand = (currentBrand) => {
        // Find the current brand container
        const currentBrandElement = document.querySelector(
          `.brand__container[data-brand="${currentBrand.toLowerCase()}"]`
        );
    
        if (currentBrandElement) {
          // Find the next brand container
          const nextBrandElement =
            currentBrandElement.nextElementSibling?.classList.contains("brand__container")
              ? currentBrandElement.nextElementSibling
              : null;
    
          if (nextBrandElement) {
            nextBrandElement.scrollIntoView({ behavior: "smooth" });
          }
        }
      };


    return (
        <div className="jump__to-next-brand">
            <a
                className="jump__to-next-brand-link"
                href="#"
                onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                handleScrollToNextBrand(brandName);
                }}
            >
                Jump to Next Brand
            </a>
        </div>
    )
}

export default JumpToNextBrand;